import { useEffect } from 'react';
import { closeDrawer } from '@/stores/useRootStore';
import useAppState from './useAppState';

export default function useCloseDrawerOnBackground() {
  const appState = useAppState();

  useEffect(() => {
    if (appState === 'inactive' || appState === 'background') {
      closeDrawer();
    }
  }, [appState]);
}
